import Reflux from 'reflux';
import find from 'lodash/find';

import dataStore from '../stores/data-store';
import tooltipActions from '../actions/tooltip-actions';

export default Reflux.createStore({
	init: function () {
		this.listenTo(
			tooltipActions.showFeature,
			this.onShowFeatureInStandTooltip
		);
		this.listenTo(dataStore, this.onDataChange);
		this.state = {featureId: null, features: []};
	},

	onShowFeatureInStandTooltip: function (featureId) {
		this.state.featureId = featureId;
		this.output();
	},

	onDataChange: function (data) {
		this.state.features = data.geojson.features;
		this.output();
	},

	output: function () {
		const result =
			this.state.featureId &&
			find(
				this.state.features,
				(feature) => feature.id === this.state.featureId
			);
		this.trigger(result);
	},

	getInitialState: function () {
		return this.state;
	},
});
